import React, { useState, useEffect } from 'react';
import { Grid, TextField, Button, FormControl, Autocomplete } from "@mui/material";
import { crearTipoDeTramite, actualizarTipoDeTramite } from '../services/tipoTramite.service';
import { obtenerOficinas } from "../services/oficinas.service";
import { getAllRequisitos } from "../services/requisitos.service";
import Loader from "./Loader";
import { notification } from "antd";
const TiposDeTramiteForm = ({ 
    setIsVisibleModal,
    reload,
    setReload,
    tipoDeTramite
}) => {
    const [tipoDeTramiteData, setTipoDeTramiteData] = useState({});
    const [oficinasList, setOficinasList] = useState([]);
    const [requisitosList, setRequisitosList] = useState([]);
    const [selectedOficina, setSelectedOficina] = useState(null);
    const [selectedRequisitos, setSelectedRequisitos] = useState([]);
    const [loading, setLoading] = useState(true); // Estado de carga

    const loadOficinas = async () => {
        try {
            const data = await obtenerOficinas();
            setOficinasList(data.data);
        } catch (error) {
            console.error("Error loading oficinas:", error);
        }
    };

    const loadRequisitos = async () => {
        try {
            const data = await getAllRequisitos();
            setRequisitosList(data.data);
        } catch (error) {
            console.error("Error loading requisitos:", error);
        }
    };

    useEffect(() => {
        // Cargar oficinas y requisitos de forma paralela y esperar a que ambas se carguen
        Promise.all([loadOficinas(), loadRequisitos()]).then(() => {
            setLoading(false); // Marcar la carga como completada
        });
    }, []);

    useEffect(() => {
        if (!loading && tipoDeTramite) { // Solo ejecutar si no está cargando y hay tipoDeTramite
            setTipoDeTramiteData({
                id: tipoDeTramite?.id,
                descripcion: tipoDeTramite?.descripcion || '',
                id_oficina_inicia: tipoDeTramite.id_oficina_inicia || null,
                requisitos: tipoDeTramite.requisitos_ids || [] // Si existe, cargar los requisitos
            });

            // Configurar los requisitos seleccionados
            if (tipoDeTramite?.requisitos_ids) {
                const selReq = requisitosList.filter((req) =>
                    tipoDeTramite?.requisitos_ids.includes(req.id)
                );
                setSelectedRequisitos(selReq);
            } else {
                setSelectedRequisitos([]);
            }

            // Configurar la oficina seleccionada
            if (tipoDeTramite.id_oficina_inicia && oficinasList.length > 0) {
                const oficina = oficinasList.find((office) => 
                    Number(office.id) === Number(tipoDeTramite.id_oficina_inicia)
                );
                if (oficina) {
                    setSelectedOficina(oficina);
                }
            }
        } else if (!loading) {
            // Reiniciar el estado para un nuevo tipo de trámite
            setTipoDeTramiteData({
                id: null,
                descripcion: '',
                id_oficina_inicia: null,
                requisitos: []
            });
            setSelectedOficina(null);
            setSelectedRequisitos([]);
        }
    }, [tipoDeTramite, oficinasList, requisitosList, loading]); // Agregar 'loading' como dependencia

    const handleTipoDeTramiteSubmit = (e) => {
        e.preventDefault();
        const updatedData = {
            ...tipoDeTramiteData,
            requisitos: selectedRequisitos // Pasar los requisitos seleccionados
        };
        setLoading(true)
        if (tipoDeTramiteData.id) {
            actualizarTipoDeTramite(tipoDeTramiteData.id, updatedData).then(() => {
                setIsVisibleModal(false);
                setReload(!reload);
                setLoading(false)
                notification["success"]({
                    message: "Tipo de trámite actualizado correctamente",
                });
            });
        } else {
            crearTipoDeTramite(updatedData).then(() => {
                setIsVisibleModal(false);
                setReload(!reload);
                setLoading(false)
                notification["success"]({
                    message: "Tipo de trámite creado correctamente",
                });                
            });
        }
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setTipoDeTramiteData((prevState) => ({
            ...prevState,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    if (loading) {
        return <Loader />;
    }

    return (
        <form onSubmit={handleTipoDeTramiteSubmit}>
            <Grid container spacing={3}>
                <Grid item xs={12} sm={12}>
                    <TextField
                        label="Nombre"
                        name="descripcion"
                        size="small"
                        value={tipoDeTramiteData.descripcion}
                        onChange={handleChange}
                        fullWidth
                    />
                </Grid>
                <Grid item xs={4}>
                    <FormControl fullWidth>
                        <Autocomplete
                            size="small"
                            options={oficinasList}
                            getOptionLabel={(option) => option.nombre}
                            value={selectedOficina}
                            onChange={(e, value) => {
                                setSelectedOficina(value);
                                setTipoDeTramiteData({
                                    ...tipoDeTramiteData,
                                    id_oficina_inicia: value?.id || null
                                });
                            }}
                            renderInput={(params) => (
                                <TextField {...params} label="Oficina Inicial" variant="outlined" />
                            )}
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={8}></Grid>
                <Grid item xs={12}>
                    <FormControl fullWidth>
                        <Autocomplete
                            multiple
                            size="small"
                            options={requisitosList}
                            getOptionLabel={(option) => `[${option.codigo}] ${option.nombre}`}
                            value={selectedRequisitos}
                            onChange={(e, value) => {
                                setSelectedRequisitos(value);
                                setTipoDeTramiteData({
                                    ...tipoDeTramiteData,
                                    requisitos: value.map((r) => r.id)
                                });
                            }}
                            renderInput={(params) => (
                                <TextField {...params} label="Requisitos" variant="outlined" />
                            )}
                            ChipProps={{
                                sx: {
                                    maxHeight: '200px',
                                    overflowY: 'scroll'
                                }
                            }}
                            sx={{
                                '.MuiAutocomplete-tag': {
                                    maxWidth: '100%'
                                }
                            }}
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12}>
                    <Button type="submit" variant="contained" color="primary">
                        {tipoDeTramite ? 'Actualizar' : 'Crear'} Tipo de Trámite
                    </Button>
                </Grid>
            </Grid>
        </form>
    );
};

export default TiposDeTramiteForm;
